import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';

@Component({
  selector: 'form-switch',
  templateUrl: './switch.component.html',
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: SwitchComponent,
    multi: true
  }]
})
export class SwitchComponent implements OnInit, ControlValueAccessor {

  // Internal checkbox check state
  private _checked = false;
  @Input() name: string;
  @Input() value: string;
  @Input() label: string;
  @Input()
  get checked() { return this._checked; }
  set checked(value: boolean) {
    if (value !== this.checked) {
      this._checked = value;
    }
  }

  @Output() clickEventEmitter = new EventEmitter<boolean>();
  // It will have a reference to a function that handles changing state of the control
  private _onChangeFn: (value: any) => void = _ => { };





  constructor() { }

  ngOnInit() {
  }

  onCheckboxClick(event) {
    this.toggle();
    this._onChangeFn(this.checked);
    this.clickEventEmitter.emit(this.checked);
  }

  toggle() {
    this.checked = !this.checked;
  }


  writeValue(value: any) {
    // This ensures that checked value always will be a boolean. 
    // !!'abc' will return true, !!null - false, empty string is falsy.
    this.checked = !!value;


  }


  registerOnChange(fn) { this._onChangeFn = fn; }

  // TODO: Implement this
  registerOnTouched(fn) { }

}
